.root {
  padding: 10px;
  background: #fafafa !important;
  box-shadow: inset 0px 1px 3px 0px rgba(0,0,0,0.2), inset 0px 1px 1px 0px rgba(0,0,0,0.14), inset 0px 2px 1px -1px rgba(0,0,0,0.12) !important;
}
